/*
 * @Description: 账户管理模块
 * @Author: hujingyang
 * @LastEditors: yang chenglin
 */

import React, { useEffect, useState } from 'react';
import style from './index.module.scss';
import { Tab } from '@alifd/next';
import SMSPayment from '@/pages/AccountKeeper/components/SMSPayment';
import SMSPaymentRecord from '@/pages/AccountKeeper/components/SMSPaymentRecord';
import SMSConsumeRecord from '@/pages/AccountKeeper/components/SMSConsumeRecord';
import SMSSign from '@/pages/AccountKeeper/components/SMSSign';
import utils from '@/common/utils';
import { event, store } from '@ice/stark-data';

const TabItem = Tab.Item;

/** 账户管理模块 */
const AccountKeeper = (): JSX.Element => {
  const [currentTabKey, setCurrentTabKey] = useState('SMSPayment');// 当前tab
  const tabsList = { SMSPayment: '短信充值', SMSPaymentRecord: '充值记录', SMSSign: '签名备案' };// tabs字典


  useEffect(() => {
    init();
  }, [currentTabKey]);

  /** 初始化函数 */
  const init = (): void => {
    getPageData();

    // 从父组件中获取已保存的currentTabKey，如果该可以为本页面tabs的key,则直接赋值，否则使用原有默认值
    const setPageTabKey = store.get('currentTab');

    // 设置当前tab 高亮
    changeTabs(tabsList[setPageTabKey] ? setPageTabKey : currentTabKey);
  };
  /**  获取数据 */
  const getPageData = (): void => {
    // 订单状态字典
  };

  /**
   * tabs 改变时触发
   * @param tabKey string
   */
  const changeTabs = (tabKey: string): void => {
    setCurrentTabKey(tabKey);

    /** 设置Header面包屑 */
    utils.setBreadcrumb({
      name: '账户管理', // 一级页面名称
      url: '/web/orderSelection', // 一级页面url
      children: {
        name: tabsList[tabKey], // 一级页面名称
        url: '/web/orderSelection', // 一级页面url
      },
    });

    // 将当前key 传入父组件
    event.emit('currentTab', tabKey);
  };
  return (
    <>
      <div className="setTabsStyle">

        {/* 页面tabs shape="wrapped" */}
        <Tab
          animation
          navClassName={style.tabsStyle}
          onChange={changeTabs}
          activeKey={currentTabKey}
          className="tabStyle_hjy"
        >
          {Object.keys(tabsList).map((key) => {
            return (<TabItem title={tabsList[key]} key={key} />);
          })}
        </Tab>

        <div className={style.mainBox}>
          {currentTabKey === 'SMSPayment' && (
            <div attr-intro="短信充值"><SMSPayment onChange={changeTabs} /></div>)}

          {currentTabKey === 'SMSPaymentRecord' && (<div attr-intro="充值记录"><SMSPaymentRecord /></div>)}

          {/* {currentTabKey === 'SMSConsumeRecord' && (<div attr-intro="消耗记录"><SMSConsumeRecord /></div>)} */}

          {currentTabKey === 'SMSSign' && (<div attr-intro="签名备案"><SMSSign /></div>)}

        </div>

      </div>

    </>

  );
};
export default AccountKeeper;
